import React from 'react';
import { withRouter } from 'react-router-dom';
import { Grid } from '@material-ui/core';

import ConnectSocialMedia from '../forms/ConnectSocialMedia';

class Social extends React.Component {

  componentDidMount() {}

  async submitForm() {
    await this.personalDetailForm.submitForm();
  }

  render() {
    return (
      <div className="inf-panel">
        <p className="inf-panel-title">Connected Accounts</p>
        <p className="inf-panel-sub">Link your Instagram and YouTube.</p>
        <hr className="inf-panel-divider" />
        <Grid container>
          <Grid item xs={12} md={9}>
            <ConnectSocialMedia />
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withRouter(Social);
